import React from 'react';
import { useFormikContext } from "formik";
import ReactDOM from 'react-dom';

import './blocks/Hero/Hero';
import './blocks/OurPeople/OurPeople.edit';
import './blocks/IconsWithDescription/IconsWithDescription.edit';
import './blocks/ServiceCTA';
import './blocks/ResourceHero';
import './blocks/ResourceBody';
import './blocks/RecommendedReading/RecommendedReading';
import './blocks/LandmarkCases/LandmarkCases.edit';
import './blocks/Stepper/Stepper';
import './blocks/Button';

// form
import './blocks/LegalAdvice';
import './blocks/ThankYou/ThankYou';

import LandmarkCases from "./blocks/LandmarkCases/LandmarkCases";
import { RecommendedReading } from "./blocks/RecommendedReading/RecommendedReading";
import ThinkWeMadeAMistake from "./blocks/ThinkWeMadeAMistake/ThinkWeMadeAMistake";
import ResourceStack from "./blocks/ResourceStack/ResourceStack";

import FeatureCarousel from './components/Carousel/Carousel';
import ResourcesHeader from "./components/Resources/ResourcesHeader";
import ResourceBody from "./components/Resources/ResourcesBody";
import { LegalIntro } from "./components/GatewayForm/steps/legal";
import Accordion from "./components/Accordion/Accordion";
import { GuidedIntro } from "./components/GatewayForm/steps/guided";
import FormContextWrapper from "./components/GatewayForm/config/FormContextWrapper";

import app from './app'

const formContext = (Component) => (props) => {
    const ctx = useFormikContext();
    return <Component {...props} formikContext={ctx} />
}

const form = (Component) => app((props) => {
    return (<FormContextWrapper>
        <Component {...props} hydrating={true} />
    </FormContextWrapper>)
})

const blocks = [
    { id: 'gutenberg-feature-carousel', component: FeatureCarousel },
    { id: 'gutenberg-resource-stack', component: ResourceStack },
    { id: 'wp-block-mt-gutenberg-resource-hero', component: ResourcesHeader },
    { id: 'gutenberg-resource-body', component: ResourceBody },
    { id: 'gutenberg-landmark-cases', component: LandmarkCases },
    { id: 'gutenberg-legal-advice', component: LegalIntro },
    { id: 'gutenberg-accordion', component: Accordion },
    { id: 'gutenberg-guided-search', component: form(GuidedIntro) },
    { id: 'gutenberg-recommended-reading', component: form(formContext(RecommendedReading)) },
    { id: 'wp-block-mt-gutenberg-form-think-we-made-a-mistake', component: ThinkWeMadeAMistake },
];

window.addEventListener('DOMContentLoaded', () => {
    blocks.forEach(block => {
        const elements = document.querySelectorAll(`.${block.id}`);
        if (elements) {
            Array.from(elements).forEach(element => {
                const attributes = JSON.parse(decodeURIComponent(element.dataset.mtAttributes) || '{}');
                const Component = block.component;
                ReactDOM.hydrate(
                    <Component {...attributes} />,
                    element
                )
            })
        }
    });
})